/** @format */

import React from "react";
import { ReactComponent as PersonalIcon } from "images/svg/profile/personal.svg";
import { ReactComponent as AccesibiltyIcon } from "images/svg/profile/accessibility.svg";
import { ReactComponent as EducationIcon } from "images/svg/profile/education.svg";
import { ReactComponent as ExperienceIcon } from "images/svg/profile/experience.svg";
import { ReactComponent as LearningIcon } from "images/svg/profile/learning.svg";

const ProfileTabs = ({ setActiveTab, activeTab }) => {
  return (
    <ul className="nav profile-tabs mb-4" id="profileTabs" role="tablist">
      <li className="nav-item" role="presentation">
        <button
          className={`nav-link ${activeTab === "personal" ? "active" : ""} `}
        id="personal-tab"
          data-bs-toggle="tab"
          data-bs-target="#personal"
          type="button"
          role="tab"
          onClick={() => setActiveTab("personal")}
        >
          <PersonalIcon />
          Personal Information
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className={`nav-link ${activeTab === "education" ? "active" : ""} `}
          id="education-tab"
          data-bs-toggle="tab"
          data-bs-target="#education"
          type="button"
          role="tab"
          onClick={() => setActiveTab("education")}
        >
          <EducationIcon />
          Education and Skills
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className={`nav-link ${
            activeTab === "professional" ? "active" : ""
          } `}
          id="professional-tab"
          data-bs-toggle="tab"
          data-bs-target="#professional"
          type="button"
          role="tab"
          onClick={() => setActiveTab("professional")}
        >
          <ExperienceIcon />
          Professional Experience
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className={`nav-link ${activeTab === "learning" ? "active" : ""} `}
          id="learning-tab"
          data-bs-toggle="tab"
          data-bs-target="#learning"
          type="button"
          role="tab"
          onClick={() => setActiveTab("learning")}
        >
          <LearningIcon />
          Learning Preferences
        </button>
      </li>
      <li className="nav-item" role="presentation">
        <button
          className={`nav-link ${
            activeTab === "accessibility" ? "active" : ""
          } `}
          id="accessibility-tab"
          data-bs-toggle="tab"
          data-bs-target="#accessibility"
          type="button"
          role="tab"
          onClick={() => setActiveTab("accessibility")}
        >
          <AccesibiltyIcon />
          Accessibility
        </button>
      </li>
    </ul>
  );
};

export default ProfileTabs;
